//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectFaceList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssociationTool",1,0],[1,"InsertsToDelete",0,"SelectBodyList",0],[1,"SelectAssociationInsert",0,"SelectBodyList",0],[1,"SelectAssociationScrap",0,"SelectBodyList",0],[1,"SelectScrapOrInsert",0,"SelectFaceList",0]],[[[],"UpdatePosition",{},0,0],[[],"DeletePiercingInsert",{},0,0]],[]];
SPLM.Tooling.PiercingInsertMiniToolsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.PiercingInsertMiniToolsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.PiercingInsertMiniToolsBuilder.AssociationToolItems = Object.freeze({
    "AddintoList" : "AddintoList", "RemovefromList" : "RemovefromList"});

export default SPLM;